<template>
  <BaseButton success :disabled="!canStart" @click="submit"> Start campaign </BaseButton>
</template>

<script>
import { accountActiveSmsCampaignsClient } from '@/api/clients';

export default {
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    validStatus() {
      return ['DRAFT', 'CANCELLED', 'FAILED'].indexOf(this.smsCampaign.status) >= 0;
    },
    hasActiveThirdPartyService() {
      return this.smsCampaign?.third_party_service?.active === true;
    },
    hasContactLists() {
      return (this.smsCampaign.contact_lists || []).length > 0;
    },
    hasSmsMessage() {
      return this.smsCampaign.sms_message_id !== null;
    },
    isScheduled() {
      return this.smsCampaign.starts_at !== null;
    },
    canStart() {
      return (
        this.validStatus &&
        this.hasActiveThirdPartyService &&
        this.hasContactLists &&
        this.hasSmsMessage &&
        this.isScheduled
      );
    },
  },
  methods: {
    submit() {
      if (this.canStart === false) {
        return;
      }

      accountActiveSmsCampaignsClient
        .store(this.smsCampaign.account_id, {
          sms_campaign_id: this.smsCampaign.id,
        })
        .then((response) => {
          this.$router.replace({
            name: 'accounts.accountId.smsCampaigns',
            params: {
              accountId: this.$route.params.accountId,
            },
            query: {
              updated: new Date().getTime(),
            },
          });

          return Promise.resolve(response);
        });
    },
  },
};
</script>
